// src/features/rrhh/empleados/api/empleadosDocumentosApi.js
import httpClient from "../../../../shared/api/httpClient";

const empleadosDocumentosApi = {
  obtenerLegajoPdf: (empleadoId) => {
    if (!empleadoId) throw new Error("empleadoId es requerido");
    return httpClient.getBlob(`/hr/administration/employees/${empleadoId}/legajo/pdf`);
  },
};

export default empleadosDocumentosApi;

export async function descargarLegajoPdf(empleadoId) {
  const blob = await empleadosDocumentosApi.obtenerLegajoPdf(empleadoId);

  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `legajo-empleado-${empleadoId}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}